import React, { useState } from 'react';
import { Box, Skeleton } from '@mui/material';
import HTMLContent from './HTMLContent';

const Image = (props) => {
  const [loading, setLoading] = useState(false);

  const getImageURL = () => {
    if (!props.imageFileName || props.imageFileName.length === 0)
      return undefined;

    if (props.imageFileName.startsWith('/')) {
      return props.imageFileName;
    }

    if (props.imageFileName.startsWith('images/')) {
      return `/${props.imageFileName}`;
    }

    return `/images/${props.imageFileName}`;
  };

  const imageURL = getImageURL();

  const getWidth = () => {
    if (props.multiImage && props.landscape) {
      return '600px';
    } else if (props.multiImage) {
      return '400px';
    } else {
      return 'auto';
    }
  };

  return (
    <Box component={props.imageTitle ? 'figure' : 'div'} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', m: 0, py: 2, maxWidth: '100%', minWidth: 0 }}>
      {loading && <Skeleton variant='rectangular' />}
      {!loading && <>
          <img
            onLoad={() => setLoading(false)}
            src={imageURL}
            alt={props.imageAlt}
            loading='lazy'
            style={{ width: getWidth(), maxWidth: '100%', height: 'auto' }}
            // maxHeight={props.multiImage && '500px'}
          />
          {props.imageTitle && <Box component="figcaption" sx={{ mt: 1, color: 'text.secondary', textAlign: 'center' }}><HTMLContent content={props.imageTitle} /></Box>}
        </>}
    </Box>
  );
};

export default Image;
